import React from "react";
import "./Whychoose.css";
import ross from "../img/aaaservices/autoiia.jpg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faRocket,
  faPalette,
  faHandshake,
  faCogs,
  faShieldAlt,
  faUserCheck,
} from "@fortawesome/free-solid-svg-icons";

const features = [
  {
    icon: faRocket,
    title: "Innovative Technology",
    text: "We utilize cutting-edge virtual reality technology to give you a fully immersive design experience.",
  },
  {
    icon: faPalette,
    title: "Personalized Design",
    text: "Every client is unique, and we tailor each design to your specific needs and lifestyle.",
  },
  {
    icon: faHandshake,
    title: "Expert Team",
    text: "Our skilled designers and specialists bring years of experience and creativity.",
  },
  {
    icon: faCogs,
    title: "Seamless Experience",
    text: "From concept to completion, we ensure a smooth and stress-free process.",
  },
  {
    icon: faShieldAlt,
    title: "Commitment to Quality",
    text: "We deliver high-quality designs that look stunning and last long.",
  },
  {
    icon: faUserCheck,
    title: "Customer Satisfaction",
    text: "Your satisfaction is our top priority throughout the entire journey.",
  },
];

const WhyChooseUs = () => {
  return (
    <section className="why-section">
      <div className="why-wrapper">
        {/* Center Heading */}
        <div className="why-header">
          <h2>
            Why <span style={{color:"orange"}}>Choose Us</span>
          </h2>
          <p>
            Transforming your vision into reality with cutting-edge technology
            and creative expertise.
          </p>
        </div>

        {/* Main Content */}
        <div className="why-container">
          {/* Left Image */}
          <div className="why-image">
            <img src={ross} alt="Why Choose Us" />
          </div>

          {/* Right Content */}
          <div className="why-content">
            <div className="why-grid">
              {features.map((item, index) => (
                <div className="why-card" key={index}>
                  <div className="why-icon">
                    <FontAwesomeIcon icon={item.icon} />
                  </div>
                  <h4>{item.title}</h4>
                  <p>{item.text}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
